import SectionHeader from "@/components/ui/section-header";

interface ResponsibilityRow {
  proxidize: string;
  customer: string;
}

const RESPONSIBILITIES: ResponsibilityRow[] = [
  {
    proxidize: "Residential-Proxy-Gateway und Exit-Netzwerk",
    customer: "Scraper, Browser, Agent oder HTTP-Client",
  },
  {
    proxidize: "Land-, Stadt- und ISP-Targeting",
    customer: "URLs, Tasks und Erfassungsplan",
  },
  {
    proxidize: "Rotierende und sticky Session-Steuerung",
    customer: "Cookies, Browser-Status und Anwendungs-Sessions",
  },
  { proxidize: "HTTP-, HTTPS- und SOCKS5-Zugriff", customer: "Rendering und Seiteninteraktion" },
  { proxidize: "Zugangsdaten und Access Points", customer: "Retry- und Concurrency-Richtlinie" },
  { proxidize: "Nutzungs-Dashboard und API", customer: "Parsing, Validierung und Speicherung" },
];

export default function ResidentialWhoItsForDe() {
  return (
    <section
      className="py-section-sm border-border border-b"
      aria-labelledby="residential-who-its-for-heading"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <SectionHeader
            eyebrow="Für wen"
            id="residential-who-its-for-heading"
            heading="Für wen Proxidize Residential Proxies gemacht sind"
            body="Für Teams, die bereits einen Scraper, Browser, KI-Agenten, Rank-Tracker oder ein Preisüberwachungssystem betreiben und die Netzwerkebene darunter benötigen — Proxidize liefert Proxy-Gateway, Exits, Targeting und Session-Steuerung; der Client wird vom Kunden betrieben."
          />
        </div>

        <div className="border-border bg-card mt-8 overflow-x-auto rounded-2xl border">
          <table className="w-full border-collapse text-left text-sm">
            <thead>
              <tr className="border-border border-b">
                <th className="text-foreground px-5 py-3 font-semibold sm:px-6">
                  Proxidize liefert
                </th>
                <th className="text-foreground px-5 py-3 font-semibold sm:px-6">Sie betreiben</th>
              </tr>
            </thead>
            <tbody>
              {RESPONSIBILITIES.map((row) => (
                <tr key={row.proxidize} className="border-border/60 border-b last:border-b-0">
                  <td className="text-muted-foreground px-5 py-3 leading-relaxed sm:px-6">
                    {row.proxidize}
                  </td>
                  <td className="text-muted-foreground px-5 py-3 leading-relaxed sm:px-6">
                    {row.customer}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="text-muted-foreground mt-6 max-w-3xl text-sm leading-relaxed">
          Auf der Suche nach einem Anbieter, der Seiten rendert und strukturierte Datensätze
          zurückgibt? Dafür eignet sich eine verwaltete Scraping-API — Proxidize liefert
          Proxy-Infrastruktur, keinen verwalteten Extraktionsdienst.
        </p>
      </div>
    </section>
  );
}
